import { format } from 'date-fns';
import { MeetingBookingStatus } from 'generated-graphql/types';

export const calendarBookingStatusHelperText = {
  [MeetingBookingStatus.Cancelled]: 'Meeting was cancelled',
  [MeetingBookingStatus.Rescheduled]: 'Meeting was rescheduled',
  [MeetingBookingStatus.ReschedulingRequested]: 'Candidate asked to reschedule',
  [MeetingBookingStatus.Scheduled]: 'Candidate scheduled'
};

export const calendarBookingStatusText = {
  [MeetingBookingStatus.Cancelled]: 'Cancelled',
  [MeetingBookingStatus.Rescheduled]: 'Rescheduled',
  [MeetingBookingStatus.ReschedulingRequested]: 'Reschedule requested',
  [MeetingBookingStatus.Scheduled]: 'Scheduled'
};

export const calendarBookingStatusType = {
  [MeetingBookingStatus.Cancelled]: 'error',
  [MeetingBookingStatus.Rescheduled]: 'success',
  [MeetingBookingStatus.ReschedulingRequested]: 'warning',
  [MeetingBookingStatus.Scheduled]: 'success'
} as const;

const formatTimeRange = (startDateTime: string, endDateTime: string) => {
  return `${format(new Date(startDateTime), 'HH:mm')} - ${format(
    new Date(endDateTime),
    'HH:mm'
  )}, ${format(new Date(startDateTime), 'EEEE d MMM yyyy')}`;
};

export const calendarBookingFormatScheduledFor = (
  startDateTime: string,
  endDateTime: string
) => {
  return formatTimeRange(startDateTime, endDateTime);
};
